/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { GramError } from "./gramerror.js";

export type RegistryDiscoverydiscoverServersResponseBodyData = {
  error: string;
};

export class RegistryDiscoverydiscoverServersResponseBody extends GramError {
  error: string;

  /** The original data that was passed to this error instance. */
  data$: RegistryDiscoverydiscoverServersResponseBodyData;

  constructor(
    err: RegistryDiscoverydiscoverServersResponseBodyData,
    httpMeta: { response: Response; request: Request; body: string },
  ) {
    const message = "message" in err && typeof err.message === "string"
      ? err.message
      : `API error occurred: ${JSON.stringify(err)}`;
    super(message, httpMeta);
    this.data$ = err;
    this.error = err.error;

    this.name = "RegistryDiscoverydiscoverServersResponseBody";
  }
}

/** @internal */
export const RegistryDiscoverydiscoverServersResponseBody$inboundSchema:
  z.ZodMiniType<RegistryDiscoverydiscoverServersResponseBody, unknown> = z.pipe(
    z.object({
      error: z.string(),
      request$: z.custom<Request>(x => x instanceof Request),
      response$: z.custom<Response>(x => x instanceof Response),
      body$: z.string(),
    }),
    z.transform((v) => {
      return new RegistryDiscoverydiscoverServersResponseBody(v, {
        request: v.request$,
        response: v.response$,
        body: v.body$,
      });
    }),
  );
